// src/config/auth0Config.ts

export const auth0Config = {
  domain: import.meta.env["VITE_AUTH0_DOMAIN"] || "",
  clientId: import.meta.env["VITE_AUTH0_CLIENT_ID"] || "",
  redirectUri:
    import.meta.env["VITE_AUTH0_CALLBACK_URL"] || window.location.origin,
  audience: import.meta.env["VITE_AUTH0_AUDIENCE"], // This is crucial for getting access tokens
  scope: "openid profile email offline_access", // Added offline_access for refresh tokens
  // TODO: Enable remember me functionality
  cacheLocation: "localstorage" as const,
  useRefreshTokens: true,
};

// Validate configuration
if (!auth0Config.domain || !auth0Config.clientId) {
  console.error(
    "Auth0 configuration is missing. Please check your environment variables."
  );

  if (!auth0Config.audience) {
    console.error(
      "Auth0 audience is missing. This is required for API access tokens."
    );
  }
}
